import styled from 'styled-components'

export const Content = styled.div`
	padding-left: 56px;

	@media only screen and (max-width: 1250px) {
		padding-left: 44px;
	}
`
